var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[[_c('router-view',{attrs:{"name":"header"}}),_c('router-view',{staticClass:"body"}),_c('router-view',{attrs:{"name":"footer"}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }